import styled from "styled-components";

export const OverflowSpan = styled.span`
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    width: 100%;
    word-break: break-all;
    overflow: hidden;
    padding-left: 0.2rem;
`;

export const DivFlex = styled.div`
    display: flex;
    align-items: center;
`;

export const DivFlexColumn = styled.div`
    display: flex;
    flex-direction: column;
`;

export const DivIcons = styled.div`
    display: flex;
    align-items: center;
    margin: 0 4px;
    padding: 0 0 1px 0;
    border-bottom: 1px solid transparent;

    >svg{
        margin-right: 2px;
    }

    transition: 100ms ease;
    
    &:hover{
        cursor: pointer;
        border-bottom: 1px solid var(--default-color-font);
    }
`;
